import React from 'react'
import SliderGallery from '../components/SliderGallery'



const BrickGallery = () => {

  const galleryImages = [
    // {
    //   img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/AdobeStock_193966827_BRICK-min.jpg"
    // },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Brick-12-rotated.jpg",
      alt:"Dec-Tec membrane in various applications and settings 1"
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Brick-11.jpg",
      alt:"Dec-Tec membrane in various applications and settings 2"
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Brick-9.jpg",
      alt:"Dec-Tec membrane in various applications and settings 3"
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Brick-10.jpeg",
      alt:"Dec-Tec membrane in various applications and settings 4"
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Brick-6.jpg",
      alt:"Dec-Tec membrane in various applications and settings 5"
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Brick-5.jpg",
      alt:"Dec-Tec membrane in various applications and settings 6"
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Brick-4.jpg",
      alt:"Dec-Tec membrane in various applications and settings 7"
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Brick-3-rotated.jpg",
      alt:"Dec-Tec membrane in various applications and settings 8"
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Brick-2.jpg",
      alt:"Dec-Tec membrane in various applications and settings 9"
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/Brick-8.jpg",
      alt:"Dec-Tec membrane in various applications and settings 10"
    },
    {
      img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/shutterstock_1067482226_brick-edt-3-1.jpg",
      alt:"Dec-Tec membrane in various applications and settings 11"
    },
    // {
    //   img: "https://dectecstorageprod.blob.core.windows.net/website/images/products/gallery/AdobeStock_46360603_BRICK-min-e1542137162671.jpg",
    //   alt:"Dec-Tec membrane in various applications and settings 12"
    // },
  ]
  return (
    <div>
      <SliderGallery
        title="Brick"
        para1="A staple in our Classic Line, Brick is a popular, neutral design that we can’t keep on the shelves. It is a tough, clean, and timeless waterproof decking product."
        galleryImages={galleryImages}
        previouslink="/bronze-gallery/"
        nextlink="/granite-gallery/"
      />
    </div>
  )
}

export default BrickGallery
